(ns common.db.effects.binary
  (:require ["@zip.js/zip.js/lib/zip-no-worker.js" :as zip]
            [goog.dom :as gdom]
            [promesa.core :as p]
            [re-frame.core :as rf]))

(defn download [blob filename]
  (let [el (gdom/createElement "a")
        url (.createObjectURL js/URL blob)
        props {:href url :download filename}]
    (gdom/setProperties el (clj->js props))
    (.click el)
    (.revokeObjectURL js/URL (.-href el))))

(defn zip! [files {:keys [on-success on-failure]}]
  (let [zip-writer (zip/ZipWriter. (zip/BlobWriter. "application/zip"))]
    (-> (p/all (map (fn [{:keys [url name]}]
                      (.add zip-writer name (zip/HttpReader. url)))
                    files))
        (p/then (fn [_]
                  (.close zip-writer)))
        (p/then (fn [zip-blob]
                  (on-success zip-blob)))
        (p/catch (fn [err]
                   (on-failure err))))))

(rf/reg-fx :binary/download
  (fn [{:keys [blob filename]}]
    (download blob filename)))
